"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var ModalV2_1 = __importDefault(require("@src/components/ModalV2"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var withTooltip_1 = __importDefault(require("relements/build/esm/overlays/withTooltip"));
var accordion_1 = __importDefault(require("relements/build/esm/ui/accordion"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
var store_1 = __importDefault(require("@src/store"));
var calenderV2_svg_1 = __importDefault(require("@src/components/Icon/calenderV2.svg"));
var entities_svg_1 = __importDefault(require("@src/components/Icon/entities.svg"));
var skillsets_svg_1 = __importDefault(require("@src/components/Icon/skillsets.svg"));
var nodesIcon_svg_1 = __importDefault(require("@src/components/Icon/nodesIcon.svg"));
var connectionsV2_svg_1 = __importDefault(require("@src/components/Icon/connectionsV2.svg"));
var generalNodes_svg_1 = __importDefault(require("@src/components/Icon/generalNodes.svg"));
var arrow_svg_1 = __importDefault(require("@src/components/Icon/arrow.svg"));
var avatar_svg_1 = __importDefault(require("@src/components/Icon/avatar.svg"));
var const_1 = require("@src/const");
var PreviewTransferModal_scss_1 = __importDefault(require("./PreviewTransferModal.scss"));
var defaults = {
    modalActive: false,
    closeModal: function () { return null; },
    previewData: {},
    previewMeta: {},
    onTransferClick: function () { return null; },
    trainStatus: null,
};
var PreviewTransferModal = function (_a) {
    var _b = _a === void 0 ? defaults : _a, modalActive = _b.modalActive, previewData = _b.previewData, previewMeta = _b.previewMeta, onTransferClick = _b.onTransferClick, trainStatus = _b.trainStatus, closeModal = _b.closeModal;
    var entities = previewData.entities, contributors = previewData.contributors, skillsets = previewData.skillsets, general_nodes = previewData.general_nodes, botSynonyms = previewData.bot_synonyms;
    var user_timer = null;
    var user_timer_seconds = 0;
    var last_transferred_date = previewMeta.last_transferred_date;
    var mixPanelTracker = store_1["default"].getMixPanel();
    var _c = react_1.useState([true, true, true]), accordionActive = _c[0], setAccordionActive = _c[1];
    var _d = react_1.useState({}), withNodesAccordionActive = _d[0], setWithNodesAccordionActive = _d[1];
    var _e = react_1.useState({}), tooltipState_entities = _e[0], setTooltipState_entities = _e[1];
    var _f = react_1.useState({}), tooltipState_skillset = _f[0], setTooltipState_skillset = _f[1];
    var _g = react_1.useState({}), tooltipState_skill = _g[0], setTooltipState_skill = _g[1];
    var _h = react_1.useState({}), tooltipState_node = _h[0], setTooltipState_node = _h[1];
    var _j = react_1.useState({}), tooltipState_connection = _j[0], setTooltipState_connection = _j[1];
    var _k = react_1.useState({}), toggleState_entityAuthors = _k[0], setToggleState_entityAuthors = _k[1];
    var _l = react_1.useState({}), toggleState_skillsetAuthors = _l[0], setToggleState_skillsetAuthors = _l[1];
    var _m = react_1.useState({}), toggleState_skillAuthors = _m[0], setToggleState_skillAuthors = _m[1];
    var _o = react_1.useState({}), toggleState_nodeAuthors = _o[0], setToggleState_nodeAuthors = _o[1];
    var _p = react_1.useState({}), toggleState_connectionAuthors = _p[0], setToggleState_connectionAuthors = _p[1];
    var _q = react_1.useState({}), tooltipState_generalNodes = _q[0], setTooltipState_generalNodes = _q[1];
    var _r = react_1.useState({}), toggleState_generalNodeAuthors = _r[0], setToggleState_generalNodeAuthors = _r[1];
    var contributors_arr = contributors
        ? Object.values(contributors).sort(function (a, b) {
            return a.user_display_name
                .toLowerCase()
                .localeCompare(b.user_display_name.toLowerCase());
        })
        : [];
    var sendUserTotalTime = function () {
        if (user_timer_seconds > 0) {
            mixPanelTracker.track({
                event: const_1.MIX_PANEL.PREVIEW_TRANSFER.TOTAL_TIME_PAGE,
                payload: {
                    TotalTimeonPage: user_timer_seconds,
                },
            });
        }
    };
    react_1.useEffect(function () {
        if (modalActive === true) {
            user_timer = setInterval(function () {
                user_timer_seconds += 1;
            }, 1000);
        }
        else {
            sendUserTotalTime();
            clearInterval(user_timer);
            user_timer_seconds = 0;
        }
        return function () {
            sendUserTotalTime();
            clearInterval(user_timer);
            user_timer_seconds = 0;
        };
    }, [modalActive]);
    /** :
     * Toggle Accordion
     */
    var toggleAccordion = function (i) {
        var accordion_arr = __spreadArrays(accordionActive);
        accordion_arr[i] = !accordion_arr[i];
        setAccordionActive(accordion_arr);
        var event = '';
        var payloadLabel = '';
        switch (i) {
            case 0:
                event = !accordion_arr[i]
                    ? const_1.MIX_PANEL.PREVIEW_TRANSFER.ENTITY_SECTION_EXPANDED
                    : const_1.MIX_PANEL.PREVIEW_TRANSFER.ENTITY_SECTION_COLLAPSED;
                payloadLabel = !accordion_arr[i]
                    ? 'entitySectionExpanded'
                    : 'entitySectionCollapsed';
                break;
            case 1:
                event = !accordion_arr[i]
                    ? const_1.MIX_PANEL.PREVIEW_TRANSFER.SKILLSET_SECTION_EXPANDED
                    : const_1.MIX_PANEL.PREVIEW_TRANSFER.SKILLSET_SECTION_COLLAPSED;
                payloadLabel = !accordion_arr[i]
                    ? 'skillsetSectionExpanded'
                    : 'skillsetSectionCollapsed';
                break;
            case 2:
                event = !accordion_arr[i]
                    ? const_1.MIX_PANEL.PREVIEW_TRANSFER.FAQ_SECTION_EXPANDED
                    : const_1.MIX_PANEL.PREVIEW_TRANSFER.FAQ_SECTION_COLLAPSED;
                payloadLabel = !accordion_arr[i]
                    ? 'faqSectionExpanded'
                    : 'faqSectionCollapsed';
                break;
        }
        mixPanelTracker.track({
            event: event,
            payload: {
                payloadLabel: true,
            },
        });
    };
    var trackMixPanelTooltip = function (changeType, element_type) {
        switch (changeType) {
            case 0:
                mixPanelTracker.track({
                    event: const_1.MIX_PANEL.PREVIEW_TRANSFER.HOVER_ON_GREEN,
                    payload: {
                        hoverOnGreen: true,
                        elementType: element_type,
                    },
                });
                break;
            case 1:
                mixPanelTracker.track({
                    event: const_1.MIX_PANEL.PREVIEW_TRANSFER.HOVER_ON_YELLOW,
                    payload: {
                        hoverOnYellow: true,
                        elementType: element_type,
                    },
                });
                break;
            case 2:
                mixPanelTracker.track({
                    event: const_1.MIX_PANEL.PREVIEW_TRANSFER.HOVER_ON_RED,
                    payload: {
                        hoverOnRed: true,
                        elementType: element_type,
                    },
                });
                break;
            case 3:
                mixPanelTracker.track({
                    event: const_1.MIX_PANEL.PREVIEW_TRANSFER.HOVER_ON_GREY,
                    payload: {
                        hoverOnGrey: true,
                        elementType: element_type,
                    },
                });
                break;
        }
    };
    /**
     * Toggle tooltip entities on mouse over
     */
    var toggleTooltipEntities = function (flag, key) {
        var state = {};
        state[key] = flag;
        setTooltipState_entities(state);
    };
    /**
     * Toggle tooltip skillsets on mouse over
     */
    var toggleTooltipSkillset = function (flag, key) {
        var state = {};
        state[key] = flag;
        setTooltipState_skillset(state);
    };
    /**
     * Toggle tooltip skill on mouse over
     */
    var toggleTooltipSkill = function (flag, key) {
        var state = {};
        state[key] = flag;
        setTooltipState_skill(state);
    };
    /**
     * Toggle tooltip node on mouse over
     */
    var toggleTooltipNode = function (flag, key) {
        var state = {};
        state[key] = flag;
        setTooltipState_node(state);
    };
    /**
     * Toggle tooltip general node on mouse over
     */
    var toggleTooltipGeneralNode = function (flag, key) {
        var state = {};
        state[key] = flag;
        setTooltipState_generalNodes(state);
    };
    /**
     * Toggle tooltip connection on mouse over
     */
    var toggleTooltipConnection = function (flag, key) {
        var state = {};
        state[key] = flag;
        setTooltipState_connection(state);
    };
    /**
     * Toggle entities author collapsed state
     */
    var toggleAuthorsEntities = function (flag, key) {
        var state = __assign({}, toggleState_entityAuthors);
        state[key] = flag;
        setToggleState_entityAuthors(state);
    };
    /**
     * Toggle skillset author collapsed state
     */
    var toggleAuthorsSkillset = function (flag, key) {
        var state = __assign({}, toggleState_skillsetAuthors);
        state[key] = flag;
        setToggleState_skillsetAuthors(state);
    };
    /**
     * Toggle skill author collapsed state
     */
    var toggleAuthorsSkill = function (flag, key) {
        var state = __assign({}, toggleState_skillAuthors);
        state[key] = flag;
        setToggleState_skillAuthors(state);
    };
    /**
     * Toggle node author collapsed state
     */
    var toggleAuthorsNode = function (flag, key) {
        var state = __assign({}, toggleState_nodeAuthors);
        state[key] = flag;
        setToggleState_nodeAuthors(state);
    };
    /**
     * Toggle node author collapsed state
     */
    var toggleAuthorsGeneralNode = function (flag, key) {
        var state = __assign({}, toggleState_generalNodeAuthors);
        state[key] = flag;
        setToggleState_generalNodeAuthors(state);
    };
    /**
     * Toggle connection author collapsed state
     */
    var toggleAuthorsConnection = function (flag, key) {
        var state = __assign({}, toggleState_connectionAuthors);
        state[key] = flag;
        setToggleState_connectionAuthors(state);
    };
    /**
     * Renders tooltip indicator
     */
    var renderTooltipIndicator = function (changeType) {
        switch (changeType) {
            case 0:
                return 'releaseLogListItemTooltipIndicatorAdded';
            case 1:
                return 'releaseLogListItemTooltipIndicatorModified';
            case 2:
                return 'releaseLogListItemTooltipIndicatorRemoved';
            default:
                return '';
        }
    };
    /**
     * Renders tooltip indicator info
     */
    var renderTooltipIndicatorInfo = function (changeType) {
        switch (changeType) {
            case 0:
                return 'releaseLogListItemTooltipInfoAdded';
            case 1:
                return 'releaseLogListItemTooltipInfoModified';
            case 2:
                return 'releaseLogListItemTooltipInfoRemoved';
            default:
                return '';
        }
    };
    /**
     * Renders tooltip indicator info pre text
     */
    var renderTooltipIndicatorInfoText = function (changeType) {
        switch (changeType) {
            case 0:
                return 'Added';
            case 1:
                return 'Changed the';
            case 2:
                return 'Removed';
            default:
                return '';
        }
    };
    /**
     * Renders tooltip item date
     * @param dt
     * @returns
     */
    var renderTooltipDate = function (dt) {
        var nth = function (d) {
            if (d > 3 && d < 21)
                return 'th';
            switch (d % 10) {
                case 1:
                    return 'st';
                case 2:
                    return 'nd';
                case 3:
                    return 'rd';
                default:
                    return 'th';
            }
        };
        var date = dt.getDate();
        var month = dt.toLocaleString('default', { month: 'short' });
        var year = dt.getFullYear();
        var hours = dt.getHours() % 12 || 12;
        var hours_24 = dt.getHours();
        var minutes = dt.getMinutes();
        return "" + date + nth(date) + " " + month + ", " + year + " at " + hours + ":" + (minutes < 10 ? "0" + minutes : minutes) + " " + (hours_24 >= 12 ? 'PM' : 'AM');
    };
    /**
     *
     * @param tooltipItem Renders tooltip author item
     * @param showToggle
     * @param count
     * @param toggleAuthors
     * @returns
     */
    var renderTooltipItemAuthor = function (tooltipItem, showToggle, count, toggleAuthors) {
        if (showToggle === void 0) { showToggle = false; }
        if (count === void 0) { count = 0; }
        return (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogTooltipItem },
            tooltipItem.profile_pic_url ? (react_1["default"].createElement("img", { src: tooltipItem.profile_pic_url, className: PreviewTransferModal_scss_1["default"].releaseLogTooltipItemAvatar, alt: "user" })) : (react_1["default"].createElement(icon_1["default"], { src: avatar_svg_1["default"], className: PreviewTransferModal_scss_1["default"].releaseLogTooltipItemAvatar })),
            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogTooltipItemRHS },
                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogTooltipItemUsers },
                    react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogTooltipItemUser },
                        tooltipItem.user_display_name,
                        showToggle && (react_1["default"].createElement(react_1["default"].Fragment, null,
                            ' ',
                            "&",
                            ' ',
                            react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold", color: "blue.haptik", onClick: function (e) { return toggleAuthors(e, false); }, className: PreviewTransferModal_scss_1["default"].releaseLogTooltipItemUserToggle },
                                count - 1,
                                " More"))))),
                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogTooltipItemDate },
                    "Last updated on",
                    ' ',
                    renderTooltipDate(new Date(tooltipItem.modified_at))))));
    };
    /**
     * Renders tooltip authors list
     */
    var renderTooltipAuthors = function (authors, openTooltip, toggleState, toggleFunction, key) {
        var authors_arr = authors
            ? Object.values(authors).sort(function (a, b) {
                return (new Date(b.modified_at) > new Date(a.modified_at) && 1) || -1;
            })
            : [];
        var showLessAuthors = toggleState[key] === undefined
            ? authors_arr.length > 2
            : toggleState[key];
        var setShowLessAuthors = function (e, flag) {
            e.stopPropagation();
            toggleFunction(flag, key);
            openTooltip(true);
        };
        var toggleAuthors = function (e) {
            e.stopPropagation();
            toggleFunction(true, key);
            openTooltip(true);
        };
        if (showLessAuthors) {
            return renderTooltipItemAuthor(authors_arr[0], showLessAuthors, authors_arr.length, setShowLessAuthors);
        }
        var authorsHtml = authors_arr.map(function (author, i) {
            return renderTooltipItemAuthor(author);
        });
        return (react_1["default"].createElement("div", null,
            authorsHtml,
            authors_arr.length > 2 && !showLessAuthors && (react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold", color: "blue.haptik", className: PreviewTransferModal_scss_1["default"].releaseLogTooltipItemToggleBtn, onClick: toggleAuthors }, "View Less"))));
    };
    /**
     * Renders Entities
     */
    var renderEntity = react_1["default"].useCallback(function (entity) {
        var authors = entity.authors, entity_name = entity.name, entity_id = entity.id, change_type = entity.change_type;
        var timer = null;
        var tooltipState = tooltipState_entities[entity_id];
        var openTooltip = function () {
            clearInterval(timer);
            toggleTooltipEntities(true, entity_id);
            trackMixPanelTooltip(change_type, 'Entity');
        };
        var closeTooltip = function () {
            timer = setTimeout(function () { return toggleTooltipEntities(false, entity_id); }, 50);
        };
        return (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItem },
            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemContent },
                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemName }, entity_name),
                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltip + " " + (tooltipState && PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipOpen) },
                    react_1["default"].createElement("div", { onMouseOver: openTooltip, onMouseOut: closeTooltip, className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicator + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicator(change_type)] }),
                    react_1["default"].createElement("div", { onMouseOver: openTooltip, onFocus: openTooltip, onMouseOut: closeTooltip, onBlur: closeTooltip, className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipContent + " " + (entity_name.length > 40 &&
                            PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipContentLeft) + " " },
                        authors &&
                            renderTooltipAuthors(authors, openTooltip, toggleState_entityAuthors, toggleAuthorsEntities, entity_id),
                        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipInfo + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicatorInfo(change_type)] },
                            react_1["default"].createElement(box_1["default"], { padding: "0", paddingBottom: "md", className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipInfoContent },
                                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicator + " " + PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicatorSmall + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicator(change_type)] }),
                                react_1["default"].createElement(text_1["default"], { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipDesc, variant: "h4.semi-bold" },
                                    renderTooltipIndicatorInfoText(change_type),
                                    ' ',
                                    react_1["default"].createElement(text_1["default"], { variant: "h4.bold" }, entity_name.length > 25
                                        ? entity_name.replace(/(.{25})..+/, '$1...')
                                        : entity_name),
                                    ' ',
                                    "entity"))))))));
    }, [entities, tooltipState_entities]);
    /**
     * Renders Connection Item
     * @param connection
     * @param i
     */
    var renderConnectionItem = function (connection, i, showDivider) {
        if (showDivider === void 0) { showDivider = false; }
        var node_id = connection.parent_id, change_type = connection.change_type, authors = connection.authors, src_node = connection.src_node, destination_node = connection.destination_node;
        var tooltipState = tooltipState_connection[src_node.id + "_" + destination_node.id];
        var timer = null;
        var openTooltip = function () {
            clearInterval(timer);
            toggleTooltipConnection(true, src_node.id + "_" + destination_node.id);
            trackMixPanelTooltip(change_type, 'Connection');
        };
        var closeTooltip = function () {
            timer = setTimeout(function () {
                return toggleTooltipConnection(false, src_node.id + "_" + destination_node.id);
            }, 50);
        };
        var textLength = src_node.name.length + destination_node.name.length;
        return (react_1["default"].createElement("div", { key: i, className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockSubItemsListItem },
            react_1["default"].createElement(box_1["default"], { alignItems: "center" },
                react_1["default"].createElement(text_1["default"], { variant: "body.md", className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockSubItemsListItemName }, src_node.name),
                react_1["default"].createElement(icon_1["default"], { src: "arrow", className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockSubItemsListItemArrow }),
                react_1["default"].createElement(text_1["default"], { variant: "body.md", className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockSubItemsListItemName }, destination_node.name),
                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltip + " " + (tooltipState && PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipOpen) },
                    react_1["default"].createElement("div", { onMouseOver: openTooltip, onMouseOut: closeTooltip, className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicator + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicator(change_type)] }),
                    react_1["default"].createElement("div", { onMouseOver: openTooltip, onFocus: openTooltip, onMouseOut: closeTooltip, onBlur: closeTooltip, className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipContent + " " + (textLength > 26 && PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipContentLeft) },
                        authors &&
                            renderTooltipAuthors(authors, openTooltip, toggleState_connectionAuthors, toggleAuthorsConnection, src_node.id + "_" + destination_node.id),
                        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipInfo + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicatorInfo(change_type)] },
                            react_1["default"].createElement(box_1["default"], { padding: "0", paddingBottom: "md", className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipInfoContent },
                                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicator + " " + PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicatorSmall + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicator(change_type)] }),
                                react_1["default"].createElement(text_1["default"], { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipDesc, variant: "h4.semi-bold" },
                                    renderTooltipIndicatorInfoText(change_type),
                                    " connection between",
                                    ' ',
                                    react_1["default"].createElement(text_1["default"], { variant: "h4.bold" }, src_node.name.length > 12
                                        ? src_node.name.replace(/(.{12})..+/, '$1...')
                                        : src_node.name),
                                    ' ',
                                    "&",
                                    ' ',
                                    react_1["default"].createElement(text_1["default"], { variant: "h4.bold" }, destination_node.name.length > 12
                                        ? destination_node.name.replace(/(.{12})..+/, '$1...')
                                        : destination_node.name),
                                    src_node.sub_story_name ? (react_1["default"].createElement(react_1["default"].Fragment, null,
                                        react_1["default"].createElement(text_1["default"], { variant: "h4.bold" },
                                            "(",
                                            src_node.sub_story_name,
                                            ' '),
                                        react_1["default"].createElement(arrow_svg_1["default"], { className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockSubItemsListItemInnerArrow }),
                                        react_1["default"].createElement(text_1["default"], { variant: "h4.bold" },
                                            ' ',
                                            destination_node.sub_story_name,
                                            ")"))) : null)))))),
            showDivider ? (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockSubItemsListItemDivider })) : null));
    };
    /**
     * Renders Node Item
     * @param node
     */
    var renderNodeItem = function (node, i) {
        var node_id = node.id, node_name = node.name, change_type = node.change_type, active = node.active, authors = node.authors;
        var tooltipState = tooltipState_node[node_id];
        var timer = null;
        var openTooltip = function () {
            clearInterval(timer);
            toggleTooltipNode(true, node_id);
            trackMixPanelTooltip(change_type, 'Node');
        };
        var closeTooltip = function () {
            timer = setTimeout(function () { return toggleTooltipNode(false, node_id); }, 50);
        };
        return (react_1["default"].createElement(box_1["default"], { key: i, className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockSubItemsListItem },
            react_1["default"].createElement(text_1["default"], { variant: "body.md", className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockSubItemsListItemName }, node_name),
            ' ',
            !active && (react_1["default"].createElement(text_1["default"], { className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockSubItemsListItemDeactivatedText, color: "grey.deep", variant: "h4.semi-bold" },
                "(deactivated)",
                ' ')),
            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltip + " " + (tooltipState && PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipOpen) },
                react_1["default"].createElement("div", { onMouseOver: openTooltip, onMouseOut: closeTooltip, className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicator + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicator(change_type)] }),
                react_1["default"].createElement("div", { onMouseOver: openTooltip, onFocus: openTooltip, onMouseOut: closeTooltip, onBlur: closeTooltip, className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipContent },
                    authors &&
                        renderTooltipAuthors(authors, openTooltip, toggleState_nodeAuthors, toggleAuthorsNode, node_id),
                    react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipInfo + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicatorInfo(change_type)] },
                        react_1["default"].createElement(box_1["default"], { padding: "0", paddingBottom: "md", className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipInfoContent },
                            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicator + " " + PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicatorSmall + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicator(change_type)] }),
                            react_1["default"].createElement(text_1["default"], { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipDesc, variant: "h4.semi-bold" },
                                renderTooltipIndicatorInfoText(change_type),
                                ' ',
                                react_1["default"].createElement(text_1["default"], { variant: "h4.bold" }, node_name),
                                " Node")))))));
    };
    /**
     * Renders Skill with Nodes and Connection Accordion
     */
    var renderNodesConnection = function (skill) {
        // const nodeList = Object.values(nodeItems) || [];
        var authors = skill.authors, active = skill.active, substory_name = skill.name, substory_id = skill.id, change_type = skill.change_type, nodes = skill.nodes, connections = skill.connections;
        var groupByConnection = function (arr) {
            return arr.reduce(function (memo, x) {
                if (!memo[x.src_node_id]) {
                    memo[x.src_node_id] = [];
                }
                memo[x.src_node_id].push(x);
                return memo;
            }, {});
        };
        var nodeList = nodes ? Object.values(nodes) : [];
        var connectionsList = connections ? Object.values(connections) : [];
        var connectionsListGroupedObj = connectionsList.length
            ? groupByConnection(connectionsList)
            : null;
        var connectionsListGrouped = connectionsListGroupedObj
            ? Object.values(connectionsListGroupedObj)
            : [];
        var accordionActive = withNodesAccordionActive[substory_id];
        var tooltipState = tooltipState_skill[substory_id];
        var newNodes = [];
        var modifiedNodes = [];
        var newConnections = [];
        var removedConnections = [];
        nodes &&
            Object.keys(nodes).forEach(function (node, i) {
                nodes[node].change_type === 0 && newNodes.push(nodes[node]);
                nodes[node].change_type === 1 && modifiedNodes.push(nodes[node]);
                nodes[node].change_type === 3 && modifiedNodes.push(nodes[node]);
            });
        connections &&
            Object.keys(connections).forEach(function (connection, i) {
                connections[connection].change_type === 0 &&
                    newConnections.push(connections[connection]);
                connections[connection].change_type === 2 &&
                    removedConnections.push(connections[connection]);
            });
        var timer = null;
        var toggleSkillAccordion = function () {
            var accordions = __assign({}, withNodesAccordionActive);
            accordions[substory_id] = !accordionActive;
            setWithNodesAccordionActive(accordions);
            if (!accordionActive) {
                mixPanelTracker.track({
                    event: const_1.MIX_PANEL.PREVIEW_TRANSFER.SKILL_SECTION_EXPANDED,
                    payload: {
                        skillSectionExpanded: true,
                    },
                });
            }
            else {
                mixPanelTracker.track({
                    event: const_1.MIX_PANEL.PREVIEW_TRANSFER.SKILL_SECTION_COLLAPSED,
                    payload: {
                        skillSectionCollapsed: true,
                    },
                });
            }
        };
        var openTooltip = function () {
            clearInterval(timer);
            toggleTooltipSkill(true, substory_id);
            trackMixPanelTooltip(change_type, 'Skill');
        };
        var closeTooltip = function () {
            timer = setTimeout(function () { return toggleTooltipSkill(false, substory_id); }, 50);
        };
        return (react_1["default"].createElement(accordion_1["default"], { useDragHandle: true, className: PreviewTransferModal_scss_1["default"].nodeConnection },
            react_1["default"].createElement(accordion_1["default"].Item, { prefixClassName: "nodeConnectionBlock", className: PreviewTransferModal_scss_1["default"].nodeConnectionBlock + "  " + (accordionActive && PreviewTransferModal_scss_1["default"].releaseLogBlockActive), renderHeader: function () { return (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockHeader },
                    react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockHeaderLHS },
                        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockHeaderTitle },
                            substory_name,
                            ' ',
                            !active && (react_1["default"].createElement(text_1["default"], { color: "grey.deep", variant: "h4.semi-bold" }, "(deactivated)"))),
                        [0, 1, 2].includes(change_type) && (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltip + " " + (tooltipState && PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipOpen) },
                            react_1["default"].createElement("div", { onMouseOver: openTooltip, onMouseOut: closeTooltip, className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicator + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicator(change_type)] }),
                            react_1["default"].createElement("div", { onMouseOver: openTooltip, onFocus: openTooltip, onMouseOut: closeTooltip, onBlur: closeTooltip, className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipContent },
                                authors &&
                                    renderTooltipAuthors(authors, openTooltip, toggleState_skillAuthors, toggleAuthorsSkill, substory_id),
                                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipInfo + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicatorInfo(change_type)] },
                                    react_1["default"].createElement(box_1["default"], { padding: "0", paddingBottom: "md", className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipInfoContent },
                                        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicator + " " + PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicatorSmall + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicator(change_type)] }),
                                        react_1["default"].createElement(text_1["default"], { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipDesc, variant: "h4.semi-bold" },
                                            renderTooltipIndicatorInfoText(change_type),
                                            ' ',
                                            react_1["default"].createElement(text_1["default"], { variant: "h4.bold" }, substory_name),
                                            " Skill"))))))),
                    react_1["default"].createElement(icon_1["default"], { src: "angle-down", className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockHeaderArrowIcon + "\n                  " + PreviewTransferModal_scss_1["default"].nodeConnectionBlockkHeaderArrowIconActive }))); }, active: accordionActive, index: 0, onChange: function () { return toggleSkillAccordion(); } },
                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockList },
                    nodeList.length ? (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockListItem },
                        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockListItemContent },
                            react_1["default"].createElement(box_1["default"], { className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockListItemHeader },
                                react_1["default"].createElement(icon_1["default"], { src: nodesIcon_svg_1["default"], className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockListItemHeaderIcon }),
                                react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold", className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockListItemName }, "Nodes")),
                            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockSubItemsList }, nodeList.map(function (node, i) { return renderNodeItem(node, i); }))))) : null,
                    connectionsListGrouped.length ? (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockListItem },
                        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockListItemContent },
                            react_1["default"].createElement(box_1["default"], { className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockListItemHeader },
                                react_1["default"].createElement(icon_1["default"], { src: connectionsV2_svg_1["default"], className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockListItemHeaderIcon }),
                                react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold", className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockListItemName }, "Connections")),
                            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].nodeConnectionBlockSubItemsList }, connectionsListGrouped.map(function (connectionList, i) {
                                return connectionList.map(function (connection, k) {
                                    return renderConnectionItem(connection, k, connectionList.length > 1 &&
                                        k + 1 == connectionList.length);
                                });
                            }))))) : null))));
    };
    /**
     * Renders skill
     */
    var renderSkill = function (skill) {
        var authors = skill.authors, active = skill.active, substory_name = skill.name, substory_id = skill.id, change_type = skill.change_type, nodes = skill.nodes, connections = skill.connections;
        var tooltipState = tooltipState_skill[substory_id];
        var modifiedNodes = [];
        var newConnections = [];
        nodes &&
            Object.keys(nodes).forEach(function (node, i) {
                nodes[node].change_type === 1 && modifiedNodes.push(nodes[node]);
                nodes[node].change_type === 3 && modifiedNodes.push(nodes[node]);
            });
        connections &&
            Object.keys(connections).forEach(function (connection, i) {
                connections[connection].change_type === 0 &&
                    newConnections.push(connections[connection]);
            });
        var timer = null;
        var openTooltip = function () {
            clearInterval(timer);
            toggleTooltipSkill(true, substory_id);
            trackMixPanelTooltip(change_type, 'Skill');
        };
        var closeTooltip = function () {
            timer = setTimeout(function () { return toggleTooltipSkill(false, substory_id); }, 50);
        };
        return (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItem },
            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemContent }, nodes || connections ? (renderNodesConnection(skill)) : (react_1["default"].createElement(react_1["default"].Fragment, null,
                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemName },
                    substory_name,
                    ' ',
                    !active && (react_1["default"].createElement(text_1["default"], { color: "grey.deep", variant: "h4.semi-bold" }, "(deactivated)"))),
                [0, 1, 2].includes(change_type) && (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltip + " " + (tooltipState && PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipOpen) },
                    react_1["default"].createElement("div", { onMouseOver: openTooltip, onMouseOut: closeTooltip, className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicator + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicator(change_type)] }),
                    react_1["default"].createElement("div", { onMouseOver: openTooltip, onFocus: openTooltip, onMouseOut: closeTooltip, onBlur: closeTooltip, className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipContent },
                        authors &&
                            renderTooltipAuthors(authors, openTooltip, toggleState_skillAuthors, toggleAuthorsSkill, substory_id),
                        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipInfo + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicatorInfo(change_type)] },
                            react_1["default"].createElement(box_1["default"], { padding: "0", paddingBottom: "md", className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipInfoContent },
                                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicator + " " + PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicatorSmall + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicator(change_type)] }),
                                react_1["default"].createElement(text_1["default"], { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipDesc, variant: "h4.semi-bold" },
                                    renderTooltipIndicatorInfoText(change_type),
                                    ' ',
                                    react_1["default"].createElement(text_1["default"], { variant: "h4.bold" }, substory_name),
                                    " Skill")))))))))));
    };
    /**
     * Renders skillset
     */
    var renderSkillSet = react_1["default"].useCallback(function (skillset) {
        var story_name = skillset.name, story_id = skillset.id, change_type = skillset.change_type, authors = skillset.authors, skills = skillset.skills, active = skillset.active;
        var timer = null;
        var newSkills = [];
        var modifiedSkills = [];
        skills &&
            Object.keys(skills).forEach(function (skill, i) {
                skills[skill].change_type === 0 && newSkills.push(skills[skill]);
                skills[skill].change_type === 1 && modifiedSkills.push(skills[skill]);
                skills[skill].change_type === 3 && modifiedSkills.push(skills[skill]);
            });
        var tooltipState = tooltipState_skillset[story_id];
        var openTooltip = function () {
            clearInterval(timer);
            toggleTooltipSkillset(true, story_id);
            trackMixPanelTooltip(change_type, 'SkillSet');
        };
        var closeTooltip = function () {
            timer = setTimeout(function () { return toggleTooltipSkillset(false, story_id); }, 50);
        };
        return (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItem },
            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemContent },
                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemName },
                    story_name,
                    ' ',
                    !active && (react_1["default"].createElement(text_1["default"], { color: "grey.deep", variant: "h4.semi-bold" }, "(deactivated)"))),
                [0, 1, 2].includes(change_type) && (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltip + " " + (tooltipState && PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipOpen) },
                    react_1["default"].createElement("div", { onMouseOver: openTooltip, onMouseOut: closeTooltip, className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicator + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicator(change_type)] }),
                    react_1["default"].createElement("div", { onMouseOver: openTooltip, onFocus: openTooltip, onMouseOut: closeTooltip, onBlur: closeTooltip, className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipContent },
                        authors &&
                            renderTooltipAuthors(authors, openTooltip, toggleState_skillsetAuthors, toggleAuthorsSkillset, story_id),
                        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipInfo + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicatorInfo(change_type)] },
                            react_1["default"].createElement(box_1["default"], { padding: "0", paddingBottom: "md", className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipInfoContent },
                                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicator + " " + PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicatorSmall + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicator(change_type)] }),
                                react_1["default"].createElement(text_1["default"], { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipDesc, variant: "h4.semi-bold" },
                                    renderTooltipIndicatorInfoText(change_type),
                                    ' ',
                                    react_1["default"].createElement(text_1["default"], { variant: "h4.bold" }, story_name),
                                    " Skillset"))))))),
            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogList + " " + PreviewTransferModal_scss_1["default"].releaseLogSubList }, skills &&
                Object.keys(skills).map(function (skill) { return renderSkill(skills[skill]); }))));
    }, [skillsets, tooltipState_skillset, renderSkill]);
    /**
     * Renders general nodes
     */
    var renderGeneralNode = react_1["default"].useCallback(function (generalNode) {
        var general_node_name = generalNode.name, general_node_id = generalNode.id, active = generalNode.active, change_type = generalNode.change_type, authors = generalNode.authors;
        var timer = null;
        var tooltipState = tooltipState_generalNodes[general_node_id];
        var openTooltip = function () {
            clearInterval(timer);
            toggleTooltipGeneralNode(true, general_node_id);
            trackMixPanelTooltip(change_type, 'FAQ');
        };
        var closeTooltip = function () {
            timer = setTimeout(function () { return toggleTooltipGeneralNode(false, general_node_id); }, 50);
        };
        return (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItem },
            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemContent },
                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemName },
                    general_node_name,
                    ' ',
                    !active && (react_1["default"].createElement(text_1["default"], { color: "grey.deep", variant: "h4.semi-bold" }, "(deactivated)"))),
                [0, 1, 2].includes(change_type) && (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltip + " " + (tooltipState && PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipOpen) },
                    react_1["default"].createElement("div", { onMouseOver: openTooltip, onMouseOut: closeTooltip, className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicator + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicator(change_type)] }),
                    react_1["default"].createElement("div", { onMouseOver: openTooltip, onFocus: openTooltip, onMouseOut: closeTooltip, onBlur: closeTooltip, className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipContent + " " + (general_node_name.length > 40 &&
                            PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipContentLeft) + " " },
                        authors &&
                            renderTooltipAuthors(authors, openTooltip, toggleState_generalNodeAuthors, toggleAuthorsGeneralNode, general_node_id),
                        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipInfo + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicatorInfo(change_type)] },
                            react_1["default"].createElement(box_1["default"], { padding: "0", paddingBottom: "md", className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipInfoContent },
                                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicator + " " + PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicatorSmall + " " + PreviewTransferModal_scss_1["default"][renderTooltipIndicator(change_type)] }),
                                react_1["default"].createElement(text_1["default"], { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipDesc, variant: "h4.semi-bold" },
                                    renderTooltipIndicatorInfoText(change_type),
                                    ' ',
                                    react_1["default"].createElement(text_1["default"], { variant: "h4.bold" }, general_node_name.length > 25
                                        ? general_node_name.replace(/(.{25})..+/, '$1...')
                                        : general_node_name),
                                    ' ')))))))));
    }, [general_nodes, tooltipState_generalNodes]);
    /**
     * Render Contributors RHS
     */
    var renderContributor = react_1["default"].useCallback(function (contributor) {
        return (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogMetaListItem },
            contributor.profile_pic_url ? (react_1["default"].createElement("img", { src: contributor.profile_pic_url, className: PreviewTransferModal_scss_1["default"].releaseLogTooltipItemAvatar, alt: "user" })) : (react_1["default"].createElement(icon_1["default"], { src: avatar_svg_1["default"], prefixClassName: "avatar", className: PreviewTransferModal_scss_1["default"].releaseLogTooltipItemAvatar })),
            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogMetaListItemDetails }, contributor.user_display_name)));
    }, [contributors]);
    /**
     * Render footer.
     */
    var renderFooter = react_1["default"].useCallback(function () {
        var needs_training = trainStatus.needs_training, training_started = trainStatus.training_started;
        var button_is_disabled = training_started !== undefined
            ? needs_training || training_started
            : true;
        var tooltip = '';
        if (training_started)
            tooltip = 'Training in Progress';
        if (needs_training)
            tooltip = 'Please train the bot first to include new changes.';
        return (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].botReleaseLogFooter },
            react_1["default"].createElement(withTooltip_1["default"], { tooltip: tooltip, position: "TOP" },
                react_1["default"].createElement(button_1["default"], { onClick: function () { return onTransferClick(); }, variant: button_is_disabled ? 'disabled' : 'primary', disabled: button_is_disabled, size: "large", type: "text", themed: true },
                    react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].botReleaseLogBtnLabel }, "Publish")))));
    }, [trainStatus]);
    var renderDate = function (dt) {
        var date = dt.getDate();
        var month = dt.toLocaleString('default', { month: 'short' });
        var year = dt.getFullYear();
        return date + " " + month + ", " + year;
    };
    var subtitle = function (date) { return (react_1["default"].createElement(text_1["default"], { variant: "body.md" },
        "LAST TRANSFERRED:",
        ' ',
        react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold" }, renderDate(new Date(date))))); };
    return (react_1["default"].createElement(ModalV2_1["default"], { title: "Release Log", subtitle: last_transferred_date && subtitle(last_transferred_date), headerIcon: null, headerSubIcon: last_transferred_date ? calenderV2_svg_1["default"] : null, active: modalActive, classPrefix: "componentModalV2", isV2: true, toggleModal: function () {
            setAccordionActive([true, true, true]);
            setWithNodesAccordionActive({});
            closeModal();
        } }, contributors && (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].botReleaseLog },
        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].botReleaseLogBody },
            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogChanges },
                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogTitle }, "Changes"),
                react_1["default"].createElement(accordion_1["default"], { useDragHandle: true },
                    entities && Object.keys(entities).length ? (react_1["default"].createElement(accordion_1["default"].Item, { prefixClassName: "releaseLogBlock", className: PreviewTransferModal_scss_1["default"].releaseLogBlock + "  " + (accordionActive[0] && PreviewTransferModal_scss_1["default"].releaseLogBlockActiveZ4), renderHeader: function () { return (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeader },
                            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderLHS },
                                react_1["default"].createElement(icon_1["default"], { src: entities_svg_1["default"], className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderIcon }),
                                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderTitle }, "Entities")),
                            react_1["default"].createElement(icon_1["default"], { src: "angle-down", className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderArrowIcon + "\n                        " + (accordionActive[0] &&
                                    PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderArrowIconActive) }))); }, active: accordionActive[0], index: 0, onChange: function (i) { return toggleAccordion(i); } },
                        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogBlockBody },
                            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogList }, entities &&
                                Object.keys(entities).map(function (entity) {
                                    return renderEntity(entities[entity]);
                                }))))) : null,
                    skillsets && Object.keys(skillsets).length ? (react_1["default"].createElement(accordion_1["default"].Item, { prefixClassName: "releaseLogBlock", className: PreviewTransferModal_scss_1["default"].releaseLogBlock + " " + (accordionActive[1] && PreviewTransferModal_scss_1["default"].releaseLogBlockActiveZ3), renderHeader: function () { return (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeader },
                            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderLHS },
                                react_1["default"].createElement(icon_1["default"], { src: skillsets_svg_1["default"], className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderIcon }),
                                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderTitle }, "Skill Sets")),
                            react_1["default"].createElement(icon_1["default"], { src: "angle-down", className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderArrowIcon + "\n                      " + (accordionActive[1] &&
                                    PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderArrowIconActive) }))); }, active: accordionActive[1], index: 1, onChange: function (i) { return toggleAccordion(i); } },
                        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogBlockBody },
                            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogList }, skillsets &&
                                Object.keys(skillsets).map(function (skillset) {
                                    return renderSkillSet(skillsets[skillset]);
                                }))))) : null,
                    botSynonyms && Object.keys(botSynonyms).length && (react_1["default"].createElement(accordion_1["default"].Item, { prefixClassName: "releaseLogBlock", className: PreviewTransferModal_scss_1["default"].releaseLogBlock + " " + (accordionActive[2] && PreviewTransferModal_scss_1["default"].releaseLogBlockActiveZ3), renderHeader: function () { return (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeader },
                            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderLHS },
                                react_1["default"].createElement(icon_1["default"], { src: skillsets_svg_1["default"], className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderIcon }),
                                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderTitle }, "Bot Synonyms")),
                            react_1["default"].createElement(icon_1["default"], { src: "angle-down", className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderArrowIcon + "\n                      " + (accordionActive[2] &&
                                    PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderArrowIconActive) }))); }, active: accordionActive[2], index: 2, onChange: function (i) { return toggleAccordion(i); } },
                        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogBlockBody }, Object.keys(botSynonyms).map(function (id) { return (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListOfContributor }, renderContributor(Object.values(botSynonyms[id].authors)[0]))); })))),
                    general_nodes && Object.keys(general_nodes).length ? (react_1["default"].createElement(accordion_1["default"].Item, { prefixClassName: "releaseLogBlock", className: PreviewTransferModal_scss_1["default"].releaseLogBlock + " " + (accordionActive[3] && PreviewTransferModal_scss_1["default"].releaseLogBlockActiveZ2), renderHeader: function () { return (react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeader },
                            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderLHS },
                                react_1["default"].createElement(icon_1["default"], { src: generalNodes_svg_1["default"], className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderIcon }),
                                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderTitle }, "FAQs")),
                            react_1["default"].createElement(icon_1["default"], { src: "angle-down", className: PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderArrowIcon + "\n                        " + (accordionActive[3] &&
                                    PreviewTransferModal_scss_1["default"].releaseLogBlockHeaderArrowIconActive) }))); }, active: accordionActive[3], index: 2, onChange: function (i) { return toggleAccordion(i); } },
                        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogBlockBody },
                            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogList }, general_nodes &&
                                Object.keys(general_nodes).map(function (generalNode) {
                                    return renderGeneralNode(general_nodes[generalNode]);
                                }))))) : null)),
            react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogMeta },
                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogMetaBlock + " " + PreviewTransferModal_scss_1["default"].releaseLogMetaBlockContributors },
                    react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogMetaBlockTitle }, "CONTRIBUTORS"),
                    contributors_arr &&
                        contributors_arr.map(function (contributor) {
                            return renderContributor(contributor);
                        })),
                react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogMetaBlock + " " + PreviewTransferModal_scss_1["default"].releaseLogMetaBlockIndicators },
                    react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogMetaBlockTitle }, "INDICATORS"),
                    react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogMetaListItem },
                        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicator + " " + PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicatorAdded }),
                        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogMetaListItemDetails }, "Element has been newly added.")),
                    react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogMetaListItem },
                        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicator + " " + PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicatorRemoved }),
                        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogMetaListItemDetails }, "Element has been removed.")),
                    react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogMetaListItem },
                        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicator + " " + PreviewTransferModal_scss_1["default"].releaseLogListItemTooltipIndicatorModified }),
                        react_1["default"].createElement("div", { className: PreviewTransferModal_scss_1["default"].releaseLogMetaListItemDetails }, "Element has been modified."))))),
        renderFooter()))));
};
exports["default"] = PreviewTransferModal;
